import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface HoverStateContentProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Whether the state is currently on/enabled */
  on: boolean;
  /** Content to show when on/enabled */
  onContent: ReactNode;
  /** Content to show when off/disabled */
  offContent: ReactNode;
  /** Content to show on hover when on/enabled */
  onHoverContent?: ReactNode;
  /** Content to show on hover when off/disabled */
  offHoverContent?: ReactNode;
  /** Additional className for the container */
  className?: string;
}

export function HoverStateContent({
  on,
  onContent,
  offContent,
  onHoverContent,
  offHoverContent,
  className,
  ...divProps
}: HoverStateContentProps) {
  const currentContent = on ? onContent : offContent;
  const hoverContent = on ? onHoverContent : offHoverContent;

  return (
    <div {...divProps} data-enabled={on} className={cn('group w-full h-full', className)}>
      {/* Default state content */}
      <span className="group-hover:hidden">{currentContent}</span>

      {/* Hover state content */}
      <span className="hidden group-hover:block">{hoverContent}</span>
    </div>
  );
}
